//export const API_SERVER = "http://localhost:5001/api/";
export const API_SERVER = "https://estate-guru.devtechub.com/api/";
